import axiosInstance from "../router/interceptor";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/bls";

async function getCountries(page?: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.post(
      `${API_URL}/countries?${page ? "page=" + page : ""}`,
      {},
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

async function getCountryById(countryId: number, page?: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.get(
      `${API_URL}/countries/${countryId}?${page ? "page=" + page : ""}`,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

async function updateById(countryId: number, updateData: any) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance
      .put(`${API_URL}/countries/${countryId}`, updateData, authorizationHeader)
      .then((response) => response?.data as CountryUpdateMeta);
  } catch (error) {
    console.error(error);

    return {
      acknowledged: false,
      matchedCount: 0,
      modifiedCount: 0,
      upsertedCount: 0,
      upsertedId: 0,
    } as CountryUpdateMeta;
  }
}

function configAuthorizationHeader() {
  let token = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");
  token = token ? token.replaceAll('"', "") : "";
  return {
    headers: {
      Authorization: "Bearer ".concat(token),
      "x-refresh-token": refreshToken,
    },
  };
}

export default {
  getCountries,
  updateById,
  getCountryById,
};

export interface CountryUpdateMeta {
  acknowledged: boolean;
  matchedCount: number;
  modifiedCount: number;
  upsertedCount: number;
  upsertedId: number;
}
